import styled from "styled-components";

export const StyledMaintenanceContainer = styled.div``;